<app-funnel-shell>
  <div class="funnel-card family-join">
    @switch (phase()) {

      @case ('loading') {
        <p class="funnel-card__intro">{{ 'family_join.loading' | translate }}</p>
      }

      @case ('not_available') {
        <h1>{{ 'gh_product.dna_family_special.name' | translate }}</h1>
        <p class="funnel-card__intro">{{ 'family_join.not_available' | translate }}</p>
        <a class="family-join__back" href="/">{{ 'funnel.intent.back_to_website' | translate }}</a>
      }

      @case ('error') {
        <h1>{{ 'gh_product.dna_family_special.name' | translate }}</h1>
        <p class="funnel-card__intro">{{ 'family_join.errors.generic' | translate }}</p>
        <a class="family-join__back" href="/">{{ 'funnel.intent.back_to_website' | translate }}</a>
      }

      @case ('dead') {
        <h1>{{ 'family_join.dead.title' | translate }}</h1>
        <p class="funnel-card__intro">{{ deadKey() | translate }}</p>
        <a class="family-join__back" href="/">{{ 'funnel.intent.back_to_website' | translate }}</a>
      }

      @default {
        <!-- 'valid' and 'accepting' -->
        <p class="family-join__kicker">
          @if (info()?.inviter_first_name; as inviter) {
            {{ 'family_join.invited_by' | translate:{ name: inviter } }}
          } @else {
            {{ 'family_join.invited' | translate }}
          }
        </p>
        <h1>{{ 'gh_product.dna_family_special.name' | translate }}</h1>
        <p class="funnel-card__intro">{{ 'gh_product.dna_family_special.tagline' | translate }}</p>

        <section class="family-join__product">
          <ul class="family-join__components">
            @for (part of ['dna', 'nutrition', 'fitness', 'dr_future', 'membership']; track part) {
              <li>
                <strong>{{ ('gh_product.dna_health_special.components.' + part + '.title') | translate }}</strong>
                <span>{{ ('gh_product.dna_health_special.components.' + part + '.text') | translate }}</span>
              </li>
            }
          </ul>
          <div class="family-join__price">
            <strong>${{ price() | number:'1.0-2' }}</strong>
            <span>{{ 'family_join.one_time' | translate }}</span>
          </div>
          <p class="family-join__notice" role="note">{{ 'gh_product.dna_family_special.no_guarantee' | translate }}</p>
          <p class="funnel-card__footnote">{{ 'membership.family.notice' | translate }}</p>
          <p class="funnel-card__footnote">{{ 'membership.bundle.contracting_party' | translate }}</p>
        </section>

        @if (acceptError(); as message) {
          <div class="alert alert-danger" role="alert">{{ message }}</div>
        }

        @if (signedIn()) {
          <button cButton color="primary" class="w-100" type="button"
                  [disabled]="phase() === 'accepting'" (click)="accept()">
            {{ (phase() === 'accepting' ? 'family_join.accepting' : 'family_join.accept') | translate }}
          </button>
        } @else {
          <div class="family-join__actions">
            <button cButton color="primary" class="w-100" type="button" (click)="createAccount()">
              {{ 'family_join.create_account' | translate }}
            </button>
            <button cButton color="secondary" variant="outline" class="w-100" type="button" (click)="signIn()">
              {{ 'family_join.sign_in' | translate }}
            </button>
          </div>
          <p class="funnel-card__footnote">{{ 'family_join.separate_account' | translate }}</p>
        }
      }
    }
  </div>
</app-funnel-shell>
